import React, { useEffect, useState } from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ModalHelp from '../../../components/ModalHelp';
import { FaCopy, FaCheck } from 'react-icons/fa';
import { ContaServico } from '../../../viewmodel/ContaServicoViewModel';
import UsuarioViewModel from '../../../viewmodel/usuario/UsuarioViewModel';
import Usuario from '../../../model/Usuario/Usuario';

type Props = {
  conta: ContaServico | null;
  onClose: () => void;
};

const AlterarSecretModal: React.FC<Props> = ({ conta, onClose }) => {
  const [copied, setCopied] = useState(false);
  const [responsavel, setResponsavel] = useState<Usuario | null>(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(`
    Olá. 
      A Administração de TI do Sistema Identifica solicita a criação de uma Conta de Serviço, 
      com a seguinte formatação:
        
        1. Criar um "client", para o cliente "Identifica", do ambiente de "PRODUÇÃO"
        2. Definir o fluxo oAuth como "client credentials"
        3. Usar como "client_id" da conta: ${conta!.clientId}
        4. Repassar client_id + secret (confidenciais) para o email do responsável: ${responsavel?.email}
    `);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const fetchResponsavel = async (responsavelId: string) => {
    try {
      const usuario = await UsuarioViewModel.getUsuario(responsavelId);
      setResponsavel(usuario || null);
    } catch (error) {
      console.error('Erro ao buscar responsável:', error);
    }
  };

  useEffect(() => {
    if (conta!.responsavelId) {
      fetchResponsavel(conta!.responsavelId);
    }
  }, [conta!.responsavelId]);

  return (
    <Modal show onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Troca de Secret da Conta de Serviço</Modal.Title>
      </Modal.Header>
      <Modal.Body>
                <ModalHelp text="Gere um novo secret (senha) para a conta de serviço. O secret anterior será invalidado imediatamente. Copie e armazene o novo secret com segurança." />
        <div className="mb-3">
          Para a troca de secret, deve-se fazer abrir um chamado para a equipe da Autenticação Central da Unicamp em:
        </div>
        
        <div className="d-flex align-items-center bg-light p-2 rounded mb-3">
          <a 
            href="https://unicamp-agil.atlassian.net/servicedesk/customer/portal/16/group/96/create/2061" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mb-0 flex-grow-1"
            style={{ overflowX: 'auto', textDecoration: 'none' }}
          >
            https://unicamp-agil.atlassian.net/servicedesk/customer/portal/16/group/96/create/2061
          </a>
        </div>

        <div className="mb-3">
          Com requisição de alteração de secret de Conta de Serviço (Cliente) para o <strong>Identifica</strong> com as seguintes instruções:
        </div>

        <div className="d-flex align-items-center bg-light p-2 rounded mb-3">
          <pre className="mb-0 flex-grow-1" style={{ overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
            Olá.<br /><br />
            A Administração de TI do Sistema Identifica solicita a alteração de senha de uma Conta de Serviço:<br />  
            <br />          
            1. Procurar o Cliente "Identifica", do ambiente de "PRODUÇÃO" no painel de Admin do Keycloak<br />            
            2. No cliente, buscar por conta com "client_id": <strong>{conta!.clientId}</strong><br />
            3. Gerar novo secret para aquela conta<br />
            4. Enviar o novo gerado para: <strong>{responsavel?.email}</strong>
          </pre>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{copied ? 'Copiado!' : 'Copiar para área de transferência'}</Tooltip>}
          >
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={handleCopy}
              className="ms-2"
            >
              {copied ? <FaCheck className="text-success" /> : <FaCopy />}
            </Button>
          </OverlayTrigger>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlterarSecretModal;